<script setup lang="ts">
import { usePublisher } from '@/utils/publisher';
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';

const publisher = usePublisher();
const route = useRoute();

onMounted(() => {
  const debugParam = route.query.param;
  
  if (debugParam && typeof debugParam === 'string') {
    publisher.publish('avee:debug', {
      param: debugParam
    });
  }
});
</script>

<template>
  <div>
    <h1>IFrame Debug</h1>
  </div>
</template>